import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {SplitText} from 'gsap/SplitText';
import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin';
gsap.registerPlugin( ScrollTrigger, SplitText, DrawSVGPlugin );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
    animate: function() {
      // global animations in animate will load in after running common.js init function, all component javascript, and before common.js finalize function.
      // This should improve animations loading in and fix odd start times due to load order


      /*
        * Wave animation on scroll
      */
      if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
        $( '.js-wave-group > [class*="hdg-"], [class*="hdg-"].js-wave' ).each( function() {
          // update the heading to have sr-only text for screen readers and add aria hidden to text that will be animated
          const text = $( this ).text();
          const hiddenSpan = `<span class="sr-only" >${text}</span>`;
          const animatedSpan = `<span class="js-wave-text" aria-hidden="true">${text}</span>`;
          $( this ).empty();
          $( this ).append( animatedSpan );
          $( this ).append( hiddenSpan );

          const animateText = new SplitText( $( this ).find( '.js-wave-text' ), {type: 'words,chars', charsClass: 'wave-letter-wrap', tag: 'span'} );
          const tl = gsap.timeline();
          const chars = animateText.chars; // an array of all the divs that wrap each character
          gsap.set( chars, {display: 'inline-block', y: 100, opacity: 0} );
          ScrollTrigger.create( {
            trigger: this,
            once: true,
            start: 'top 90%',
            // scrub: 0.15,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'js-animated' );
              }
            },
            onEnter: ( elements, triggers ) => {
              tl.to( animateText.chars, {duration: .45, y: 0, opacity: 1, stagger: 0.02} );
              $( this ).addClass( 'js-animated' );
            },
          } );
        } );

        /*
          * Fade on scroll
        */
        $( '.js-fade:not(.js-ignore), .js-fade-group > *:not(.js-ignore)' ).each( function() {
          ScrollTrigger.create( {
            trigger: this,
            start: 'top 90%',
            scrub: 0.15,
            onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'js-animated' ),
          } );
        } );

        /*
        * Reveal on scroll
        */
        $( '.js-reveal:not(.js-ignore)' ).each( function() {
          gsap.to( this, {
            scrollTrigger: {
              trigger: this,
              start: 'top 90%',
              scrub: false,
            },
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)', duration: 1.5, ease: 'power4.inOut',
          } );
        } );

        /*
        * Draw on scroll
        */
        $( '.js-draw:not(.js-ignore)' ).each( function() {
          gsap.set( $( this )[0], {width: '0%'} );
          gsap.to( $( this )[0], {
            scrollTrigger: {
              trigger: this,
              start: 'top 90%',
              scrub: false,
            },
            width: '100%',
            duration: 2,
            ease: 'power4.inOut',
          } );
        } );
      }
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
